import { Button, Flex, SimpleLayout, useLayout } from '@approvalmax/ui/src/components';
import { hooks } from '@approvalmax/utils';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { storageService } from 'services/storage';
import { getPath, Path } from 'urlBuilder';

import { Content } from './resources/components';
import { messages } from './resources/messages';

const Page = () => {
    useLayout({ containerMinSize: 'xxsmall' });

    const authenticated = storageService.authenticated();

    const [email] = hooks.useQueryParam('email');

    if (authenticated) return null;

    return (
        <SimpleLayout size='xsmall'>
            <Helmet>
                <title>{messages.title}</title>
            </Helmet>

            <SimpleLayout.Content>
                <Content />
            </SimpleLayout.Content>

            <SimpleLayout.Footer>
                <Flex justifyContent='center'>
                    <Button as={Link} to={getPath(Path.login, { email })} color='blue10'>
                        {messages.loginNowButtonText}
                    </Button>
                </Flex>
            </SimpleLayout.Footer>
        </SimpleLayout>
    );
};

export default Page;
